export const IMPORTS_API_HOST = import.meta.env.VITE_IMPORTS_API_BASE_URL;

export const IMPORTS_API = '/api/imports';

export const JOHN_DEERE_SOURCE = 'JOHN_DEERE';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
